/**
 * Google maps places API loader
 *
 * @package
 */

/**
 * Internal dependencies
 */
import mapsapi from '../map/mapsapi';

/**
 * The Google Maps places service
 *
 * @member	{typeof google.maps.places.PlacesService|null}	service	The places service
 */
let service: typeof google.maps.places.PlacesService | null = null;

/**
 * Load the places service
 *
 * @return	{Promise<typeof google.maps.places.PlacesService>}	The places service
 */
const load = () => {
	if ( service ) {
		// Service already exists, return it as a promise
		return Promise.resolve( service );
	}

	return mapsapi().then( async ( loader ) => {
		/**
		 * Load the places library
		 *
		 * @param {typeof google.maps.places.PlacesService} PlacesService The Google places library type
		 */
		return loader.importLibrary( 'places' ).then( ( { PlacesService } ) => {
			service = PlacesService;
			return service as typeof google.maps.places.PlacesService;
		} );
	} );
};

export default load;
